import { render, staticRenderFns } from "./ItemSelectionDialog.vue?vue&type=template&id=64942227&scoped=true"
import script from "./ItemSelectionDialog.vue?vue&type=script&lang=js"
export * from "./ItemSelectionDialog.vue?vue&type=script&lang=js"
import style0 from "./ItemSelectionDialog.vue?vue&type=style&index=0&id=64942227&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64942227",
  null
  
)

export default component.exports